import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Notice } from '../../models/notice.model';
import { NoticeState, noticeAdapter } from '../reducers/notice.reducer';
import { selectRouteParams } from './router.selector';

export const getNoticeState = createFeatureSelector<NoticeState>('notices');
export const getIds = (state: NoticeState) => state.ids;
// export const noticeStatsLoading = (state: NoticeState) =>
//   state.noticeStatsLoading;
export const loading = (state: NoticeState) => state.loading;
export const loaded = (state: NoticeState) => state.loaded;

export const {
  selectIds: getNoticeIds,
  selectEntities: getNoticeEntities,
  selectAll: getAllNotices,
  selectTotal: getTotalNotices,
} = noticeAdapter.getSelectors(getNoticeState);

export const inProgress = createSelector(
  getNoticeState,
  (noticeState: NoticeState) => noticeState.inProgress
);

export const getNoticesBySelectedGroup = createSelector(
  getAllNotices,
  selectRouteParams,
  (allItems, { id }) => {
    return allItems
      .filter((item) => {
        return item.groupId === id;
      })
      .sort(sortDescendingByStartDate);
  }
);

function getTime(t: any): number {
  if (!t) return 0;
  if (typeof t.toDate === 'function') {
    try {
      return t.toDate().getTime();
    } catch { }
  }
  if (t instanceof Date) return t.getTime();
  if (typeof t === 'number') return t;
  if (typeof t === 'string') return new Date(t).getTime();
  if (t.seconds !== undefined) return t.seconds * 1000;
  return 0;
}

function sortDescendingByStartDate(a: Notice, b: Notice): number {
  const timeA = getTime(a?.publishOn) || getTime(a?.modified) || getTime(a?.created);
  const timeB = getTime(b?.publishOn) || getTime(b?.modified) || getTime(b?.created);
  return timeB - timeA;
}

function sortAscendingByStartDate(a: Notice, b: Notice): number {
  const timeA = getTime(a?.publishOn) || getTime(a?.modified) || getTime(a?.created);
  const timeB = getTime(b?.publishOn) || getTime(b?.modified) || getTime(b?.created);
  return timeA - timeB;
}

export const getNoticeById = (noticeId: string) =>
  createSelector(getAllNotices, (allItems) => {
    if (allItems) {
      return allItems.find((item) => {
        return item.id === noticeId;
      });
    } else {
      return null;
    }
  });
